/**
 * DisplayModeBar — visar vilket läge HDMI-displayen är i
 * och låter facilitatorn byta med ett klick.
 * Används i SpeakerView och ScheduleSpeakerView.
 */
import React from 'react';
import { Box, Typography, Tooltip, ButtonGroup, Button } from '@mui/material';
import TvIcon from '@mui/icons-material/Tv';
import { db } from '../../../firebase/config';
import { doc, updateDoc } from 'firebase/firestore';

const MODES = [
  { key: 'blank',           label: 'Töm' },
  { key: 'intro',           label: 'Talarstöd' },
  { key: 'schedule',        label: 'Körschema' },
  { key: 'workshop',        label: 'Workshop' },
  { key: 'group-responses', label: 'Gruppsvar' },
  { key: 'analysis',        label: 'Analys' },
];

const accent = '#E05500';

export default function DisplayModeBar({ sessionId, currentMode }) {
  const setMode = (mode) =>
    updateDoc(doc(db, 'workshops', sessionId), { 'display.mode': mode });

  return (
    <Box sx={{
      display: 'flex', alignItems: 'center', gap: 1.5,
      px: 2, py: 0.75,
      bgcolor: 'rgba(255,255,255,0.03)',
      borderBottom: '1px solid', borderColor: 'divider',
    }}>
      <TvIcon sx={{ fontSize: 14, color: 'text.disabled' }} />
      <Typography fontSize="0.62rem" color="text.disabled" fontWeight={700} letterSpacing={1} sx={{ whiteSpace: 'nowrap' }}>
        HDMI-SKÄRM
      </Typography>
      <ButtonGroup size="small" variant="outlined" sx={{ ml: 0.5 }}>
        {MODES.map(m => (
          <Tooltip key={m.key} title={`Visa ${m.label.toLowerCase()} på HDMI`}>
            <Button
              onClick={() => setMode(m.key)}
              sx={{
                textTransform: 'none',
                fontSize: '0.68rem',
                px: 1.25,
                borderColor: currentMode === m.key ? accent : 'divider',
                color: currentMode === m.key ? accent : 'text.disabled',
                bgcolor: currentMode === m.key ? accent + '12' : 'transparent',
                fontWeight: currentMode === m.key ? 700 : 400,
                '&:hover': { borderColor: accent, color: accent, bgcolor: accent + '12' },
              }}
            >
              {m.label}
            </Button>
          </Tooltip>
        ))}
      </ButtonGroup>
      {currentMode && currentMode !== 'blank' && (
        <Typography fontSize="0.62rem" color={accent} sx={{ opacity: 0.7 }}>
          visar {MODES.find(m => m.key === currentMode)?.label.toLowerCase()}
        </Typography>
      )}
    </Box>
  );
}
